import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import _merge from 'lodash.merge';
import Sidebar from 'react-sidebar';
import translations from './app/translations';
import constants from './app/constants';
import StepContainer from './components/StepContainer';
import MainHeader from './components/MainHeader';
import ExitModal from './components/ExitModal';
import InsurancePopup from './components/InsurancePopup';
import ImageSlider from './components/ImageSlider';
import utils from './app/utils';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isMobile, isSafari } from 'react-device-detect';
import {
    openExitModal,
    closeExitModal,
    setData,
    resetState,
    setInsuranceEnabled,
    setInsurancePopupOpen,
    clearSelectedOptions,
    setSelectedPackage,
    setTotalPrice,
    setTotalDiscount,
    setEditModeCatEntryId,
    setInsuranceLoading,
    setInsuranceLogged,
    setEditModeWarrantyCatEntryId,
    setBlueLightAlertContent,
    setBlueLightGamingAlertContent,
    setLabels,
    setBaseURLs,
    setIsReadyCustomURL,
    setProductImage,
    setLearnMoreBackgrounds,
    setContentOnLoad,
    setAnimationInsurance,
    setBrandDisclaimer,
    setBlueDisclaimer,
    setBrandSelected,
    setTreatmentOptions,
    setTreatmentOptionsPackages,
    setTreatmentStepTitleInGvp,
    setFrameUPC,
    setBaseLensPackage,
    setEditColorLens,
    setIsLensGaming,
    setResetTotalsOnInit,
    setExtPrescriptionObject,
    setIsSimplePrescription,
    setCurrencyFormat,
    setPDEspotContent,
    setIsPrescriptionModalOpen,
    setPrescriptionSidebarEspotContent,
    setIsPDModalOpen,
    setMirrorAlertContent,
    setPaymentInstallmentsQuantity,
    setPaymentInstallmentsType,
    setProductImageOld,
    setImageErrorMessage,
    setIsGVP,
    setSelectedColorOption,
    setLensErrorMessage,
} from './app/mainSlice';
import ProductImage from './components/ProductImage';

export default ({ config }) => {
    const dispatch = useDispatch();
    const data = useSelector(state => state.main.data);
    const selectedOptions = useSelector(state => state.main.selectedOptions);
    const selectedPackage = useSelector(state => state.main.selectedPackage);
    const selectedWarranty = useSelector(state => state.main.selectedWarranty);
    const isInsuranceEnabled = useSelector(state => state.main.isInsuranceEnabled);
    const isInsuranceLoading = useSelector(state => state.main.isInsuranceLoading);
    const isInsuranceLogged = useSelector(state => state.main.isInsuranceLogged);
    const totalPrice = useSelector(state => state.main.totalPrice);
    const totalDiscount = useSelector(state => state.main.totalDiscount);
    const isExitModalOpen = useSelector(state => state.main.isExitModalOpen);
    const editColorLens = useSelector(state => state.main.editColorLens);
    const selectedColorOption = useSelector(state => state.main.selectedColorOption);
    const currentStep = useSelector(state => state.main.currentStep);
    const isLensGaming = useSelector(state => state.main.isLensGaming);
    const labels = useSelector(state => state.main.labels);
    const productImage = useSelector(state => state.main.productImage);
    const contentOnLoad = useSelector(state => state.main.contentOnLoad);
    const isLearnMoreModalOpen = useSelector(state => state.main.isLearnMoreModalOpen);
    const isReadyCustomURL = useSelector(state => state.main.isReadyCustomURL);
    const brandDisclaimer = useSelector(state => state.main.brandDisclaimer);
    const brandSelected = useSelector(state => state.main.brandSelected);
    const frameUPC = useSelector(state => state.main.frameUPC);
    const baseURLs = useSelector(state => state.main.baseURLs);
    const resetTotalsOnInit = useSelector(state => state.main.resetTotalsOnInit);
    const selectedPrescriptionObject = useSelector(state => state.main.selectedPrescriptionObject);
    const isPrescriptionModalOpen = useSelector(state => state.main.isPrescriptionModalOpen);
    const isSimplePrescription = useSelector(state => state.main.isSimplePrescription);
    const isPupillaryDistanceModalOpen = useSelector(state => state.main.isPDModalOpen);
    const prescriptionSidebarEspotContent = useSelector(
        state => state.main.prescriptionSidebarEspotContent
    );
    const pupillaryDistanceEspotContent = useSelector(state => state.main.pDEspotContent);
    const isMoreOneBrand = useSelector(state => state.main.isMoreOneBrand);
    const productImageOld = useSelector(state => state.main.productImageOld);
    const imageErrorMessage = useSelector(state => state.main.imageErrorMessage);
    const errorLoadImage = useSelector(state => state.main.errorLoadImage);
    const isGVP = useSelector(state => state.main.isGVP);
    const lensErrorMessage = useSelector(state => state.main.lensErrorMessage);

    const prescriptionModalRef = useRef(null);
    const PDModalRef = useRef(null);

    const isAnyModalOpen =
        isLearnMoreModalOpen || isPrescriptionModalOpen || isPupillaryDistanceModalOpen;

    const closePrescriptionModal = () => {
        dispatch(setIsPrescriptionModalOpen(false));
    };
    const closePDModal = () => {
        dispatch(setIsPDModalOpen(false));
    };

    const handleBackClick = () => {
        if (currentStep > 0) {
            const prevStep = currentStep - 1;
            let clearOptions = constants.stepsOptionsMap[constants.steps[prevStep]];

            if (prevStep == constants.steps.indexOf('brand') && getSingleBrand()) {
                constants.stepsOptionsMap['prescription'].forEach(option => {
                    clearOptions.push(option);
                });
                if (isSimplePrescription) {
                    constants.stepsOptionsMap['type'].forEach(option => {
                        clearOptions.push(option);
                    });
                }
            }

            if (prevStep == constants.steps.indexOf('prescription') && isSimplePrescription) {
                constants.stepsOptionsMap['type'].forEach(option => {
                    clearOptions.push(option);
                });
            }

            if (prevStep == constants.steps.indexOf('type')) {
                constants.stepsOptionsMap['prescription'].forEach(option => {
                    clearOptions.push(option);
                });
            }

            dispatch(clearSelectedOptions(clearOptions.flat()));
            dispatch(setEditColorLens(false));
            dispatch(setTreatmentOptions(null));
            dispatch(setTreatmentOptionsPackages(null));
            dispatch(setBaseLensPackage(null));
            dispatch(setIsLensGaming(false));
            dispatch(setProductImageOld(null));
            dispatch(setImageErrorMessage(false));
            dispatch(setLensErrorMessage(false));
        }
    };

    const handleContinue = () => {
        dispatch(closeExitModal());
    };

    const handleSave = () => {
        config.actionsModule.genericSaveLensSelection(
            selectedPackage.frame,
            selectedPackage.lensPackage,
            selectedWarranty,
            config.data.frame.brandImageUrl
        );

        handleExit();
    };

    const handleDiscard = () => {
        handleExit();
    };

    const handleAddInsurance = () => {
        config.insuranceModule.openInsurancePanel();
    };

    const handleExit = () => {
        // Reset main state (except data)
        dispatch(resetState());

        toggleLockPageScroll(false);

        if (typeof config.actionsModule.genericExit === 'function')
            config.actionsModule.genericExit();

        // Unmount RXC
        ReactDOM.unmountComponentAtNode(document.querySelector(config.selector));
    };

    const handleOpenExit = () => {
        if (currentStep == 0) {
            handleExit();
        } else {
            dispatch(openExitModal());
        }
    };

    const toggleLockPageScroll = lock => {
        document.querySelectorAll('html,body').forEach(elem => {
            elem.style.overflow = lock ? 'hidden' : '';
            elem.style.position = lock ? 'fixed' : '';
            elem.style.height = lock ? '100%' : '';
        });
    };

    const handleApply = () => {
        handleAddInsurance();
    };

    const handleSkip = () => {
        dispatch(setInsurancePopupOpen(false));
        setTimeout(() => {
            dispatch(setAnimationInsurance(false));
        }, 500);
    };

    // App init
    useEffect(() => {
        console.log('Init RXC');

        // Init translations
        if (config.translation) {
            if (config.translation.language && window.rxcTranslations) {
                let translationsExt = _merge(
                    {},
                    translations['default']['en_US'],
                    window.rxcTranslations[config.translation.language]
                );

                if (config.translation.brand) {
                    translationsExt = _merge(
                        {},
                        translationsExt,
                        window.rxcTranslations[config.translation.brand][
                            config.translation.language
                        ]
                    );
                }

                dispatch(setLabels(translationsExt));
            } else {
                console.warn('RXC: translations not loaded, brand or language are missing');
            }
        }

        // Init currency format
        if (config.currencyFormat) {
            let currencyFormatExt = {
                ...constants.currencyFormat,
                ...config.currencyFormat,
            };

            dispatch(setCurrencyFormat(currencyFormatExt));
        }

        // Init frame image
        let extFramesImages = constants.frameImages;

        if (config.unbrandedFrameImages) {
            extFramesImages = {
                ...extFramesImages,
                ...config.unbrandedFrameImages,
            };
        }

        let frameImage = extFramesImages[
            config.data.frame.brand.replace('-', '').replace(' ', '').toLowerCase()
        ]
            ? extFramesImages[
                  config.data.frame.brand.replace('-', '').replace(' ', '').toLowerCase()
              ]['default']
                  .replace('#PARTNUMBER#', config.data.frame.upc)
                  .replace('#MO#', config.data.frame.model)
                  .replace('#CO#', config.data.frame.color)
            : config.data.frame.imageUrl;

        // Init images base path
        if (config.baseURLs) {
            const imageURLsExt = { ...constants.baseURLs, ...config.baseURLs };

            //update frame images if necessary
            let oldWordRegEx = new RegExp(constants.baseURLs.framesImage, 'g');
            frameImage = frameImage.replace(oldWordRegEx, config.baseURLs.framesImage);

            dispatch(setBaseURLs(imageURLsExt));
        } else {
            dispatch(setIsReadyCustomURL(true));
        }

        dispatch(setProductImage(frameImage));

        toggleLockPageScroll(true);

        document.querySelector('#rxc-wcag-start').focus();

        document.querySelector('#rxc-wcag-end').addEventListener('keydown', event => {
            document.querySelector('#rxc-wcag-start').focus();
        });

        if (config.insuranceModule) {
            // Insurance event handlers
            window.addEventListener(config.insuranceModule.getEvents().INSURANCE_ENABLED, () => {
                dispatch(setInsuranceEnabled(true));
                dispatch(setInsuranceLoading(false));
            });

            window.addEventListener(config.insuranceModule.getEvents().INSURANCE_DISABLED, () => {
                dispatch(setInsuranceEnabled(false));
            });

            window.addEventListener(config.insuranceModule.getEvents().INSURANCE_LOGIN, () => {
                dispatch(setInsuranceLogged(true));
            });

            window.addEventListener(config.insuranceModule.getEvents().INSURANCE_LOGOUT, () => {
                dispatch(setInsuranceLogged(false));
                dispatch(setInsuranceEnabled(false));
            });

            dispatch(setInsuranceLoading(config.insuranceModule.isLoading()));
            dispatch(setInsuranceLogged(config.insuranceModule.isLogged()));
            dispatch(setInsuranceEnabled(config.insuranceModule.isEnabled()));
        }

        if (config.data.lens && config.data.lens.catEntryId) {
            dispatch(setEditModeCatEntryId(config.data.lens.catEntryId));
        }

        if (config.data.warranty && config.data.warranty.catEntryId) {
            dispatch(setEditModeWarrantyCatEntryId(config.data.warranty.catEntryId));
        }

        // Set prescription data
        if (config.prescriptionModule && config.data.frame.rxValues) {
            const errorMessage = 'ERROR while retrieving prescription data';
            let _isSimplePrescription = null;

            config.prescriptionModule
                .loadPrescription()
                .then(
                    function (response) {
                        if (response !== undefined && response !== null) {
                            console.log('Prescription loaded');

                            if (
                                config.prescriptionModule.prescriptionType ===
                                constants.prescriptionTypes.SIMPLE
                            ) {
                                _isSimplePrescription = true;
                            } else if (
                                config.prescriptionModule.prescriptionType ===
                                constants.prescriptionTypes.FULL
                            ) {
                                _isSimplePrescription = false;
                            }
                            dispatch(setIsSimplePrescription(_isSimplePrescription));
                            if (
                                (_isSimplePrescription &&
                                    utils.validateSimplePrescriptionObject(response)) ||
                                (_isSimplePrescription == false &&
                                    utils.validateFullPrescriptionObject(response))
                            ) {
                                dispatch(setExtPrescriptionObject(response));
                            } else {
                                throw new Error(errorMessage);
                            }
                        } else if (response == null) {
                            console.error('No prescription data found');
                            if (
                                config.prescriptionModule.prescriptionType ===
                                constants.prescriptionTypes.SIMPLE
                            ) {
                                _isSimplePrescription = true;
                            } else if (
                                config.prescriptionModule.prescriptionType ===
                                constants.prescriptionTypes.FULL
                            ) {
                                _isSimplePrescription = false;
                            }
                            dispatch(setIsSimplePrescription(_isSimplePrescription));
                        }
                    },
                    function (error) {
                        throw new Error(errorMessage);
                    }
                )
                .catch(error => {
                    console.error(errorMessage);

                    // TODO insert analytics call
                    /*
                    try {
                        tealium_data2track.push({
                            id: 'Error',
                            Error_Code: 'RX Configurator: Loading error',
                            Error_Details: errorMessage,
                            Error_Source: 'Client',
                        });
                    } catch (error) {
                        console.error(
                            'Error during tealium_data2track push. Check if tealium_data2track exists in the window.'
                        );
                    }
                    */
                });
        }

        // Set data only first time
        if (
            (config.lensesData && data == null && frameUPC == null) ||
            (data !== null && frameUPC !== null && config.data.frame.upc !== frameUPC)
        ) {
            dispatch(setFrameUPC(config.data.frame.upc));

            let tempLensesData = config.lensesData;

            // Optional frame object compatibility, lens vs lensPackage backward compatibility
            if (!config.lensesData.packages[0].frame || config.lensesData.packages[0].lens) {
                tempLensesData = utils.deepCopy(config.lensesData);

                tempLensesData.packages.forEach(currentPackage => {
                    if (!currentPackage.frame) {
                        currentPackage.frame = {
                            offerPrice: config.data.frame.listPrice,
                            insPrice: null,
                            promoType: null,
                        };
                    }

                    if (currentPackage.lens) {
                        currentPackage.lensPackage = utils.deepCopy(currentPackage.lens);
                        delete currentPackage.lens;
                    }
                });
            }

            dispatch(setData(tempLensesData));
        }

        //set installed payment
        if (config.paymentInstallment) {
            if (config.paymentInstallment.type) {
                dispatch(setPaymentInstallmentsType(config.paymentInstallment.type.toUpperCase()));
            }
            if (config.paymentInstallment.installments) {
                dispatch(setPaymentInstallmentsQuantity(config.paymentInstallment.installments));
            }
        }
    }, []);

    useEffect(() => {
        // Content load on init

        if (constants) {
            // Get blue light alert content
            let blueLightAlertContentName = isMobile
                ? constants.contentNames.blueLightAlertMobEspotName
                : constants.contentNames.blueLightAlertDeskEspotName;

            // Get gaming alert content
            let gamingContentName = isMobile
                ? constants.contentNames.blueLightGamingAlertMobEspotName
                : constants.contentNames.blueLightGamingAlertDeskEspotName;

            // Get mirror alert content
            let mirrorContentName = isMobile
                ? constants.contentNames.mirrorAlertMobContentName
                : constants.contentNames.mirrorAlertDeskContentName;

            // Get prescription sidebar content
            let prescriptionSidebarContentName = isMobile
                ? constants.contentNames.mobilePrescriptionModalEspotName
                : constants.contentNames.desktopPrescriptionModalEspotName;

            // Get learn more background content
            let learnMoreBGContentName = isMobile
                ? constants.contentNames.mobileEspotBackground
                : constants.contentNames.desktopEspotBackground;

            // Get brand disclaimer content
            let brandDisclaimerContentName = isMobile
                ? constants.contentNames.mobileBrandDisclaimer
                : constants.contentNames.desktopBrandDisclaimer;

            // Get blue disclaimer content
            let blueDisclaimerContentName = isMobile
                ? constants.contentNames.mobileBlueDisclaimer
                : constants.contentNames.desktopBlueDisclaimer;

            if (blueLightAlertContentName) {
                config.actionsModule.loadContent(blueLightAlertContentName).then(content => {
                    dispatch(setBlueLightAlertContent(content));
                });
            }

            if (gamingContentName) {
                config.actionsModule.loadContent(gamingContentName).then(content => {
                    dispatch(setBlueLightGamingAlertContent(content));
                });
            }

            if (mirrorContentName) {
                config.actionsModule.loadContent(mirrorContentName).then(content => {
                    dispatch(setMirrorAlertContent(content));
                });
            }

            if (prescriptionSidebarContentName) {
                config.actionsModule.loadContent(prescriptionSidebarContentName).then(content => {
                    dispatch(setPrescriptionSidebarEspotContent(content));
                });
            }

            //Get Pupillary Distance espot content
            if (
                config.prescriptionModule &&
                config.prescriptionModule.prescriptionType === constants.prescriptionTypes.FULL
            ) {
                let pupillaryDistanceContentName = isMobile
                    ? constants.contentNames.mobilePDModalEspotName
                    : constants.contentNames.desktopPDModalEspotName;

                if (pupillaryDistanceContentName) {
                    config.actionsModule.loadContent(pupillaryDistanceContentName).then(content => {
                        dispatch(setPDEspotContent(content));
                    });
                }
            }

            if (learnMoreBGContentName) {
                config.actionsModule.loadContent(learnMoreBGContentName).then(content => {
                    let contentArray = content.split('</div>');
                    let learnMoreBGs = {};

                    for (let i = 0; i < contentArray.length - 1; i++) {
                        let learnMoreBG = contentArray[i] + '</div>';
                        if (learnMoreBG.split('id="')[1]) {
                            let id = learnMoreBG.split('id="')[1].split('"')[0];
                            learnMoreBGs[id] = learnMoreBG;
                        }
                    }

                    dispatch(setLearnMoreBackgrounds(learnMoreBGs));
                    dispatch(setContentOnLoad(content));
                });
            }

            if (brandDisclaimerContentName) {
                config.actionsModule.loadContent(brandDisclaimerContentName).then(content => {
                    dispatch(setBrandDisclaimer(content));
                });
            }

            if (blueDisclaimerContentName) {
                config.actionsModule.loadContent(blueDisclaimerContentName).then(content => {
                    dispatch(setBlueDisclaimer(content));
                });
            }
        }
    }, [labels]);

    const resetTotals = () => {
        const frameListPrice = parseFloat(config.data.frame.listPrice);
        dispatch(setTotalPrice(frameListPrice));

        if (data !== null && config.data.frameOnlyLensUPC) {
            const planoPackage = data.packages.filter(currentPackage => {
                if (currentPackage.lensPackage.upc == config.data.frameOnlyLensUPC) {
                    return currentPackage;
                }
            });

            if (planoPackage.length == 1) {
                if (isInsuranceEnabled) {
                    if (planoPackage[0].frame.insPrice !== null) {
                        const frameOfferPrice = parseFloat(planoPackage[0].frame.insPrice);

                        dispatch(setTotalDiscount((frameListPrice - frameOfferPrice).toFixed(2)));
                    } else {
                        dispatch(setTotalDiscount(null));
                    }
                } else {
                    if (planoPackage[0].frame.offerPrice) {
                        const frameOfferPrice = parseFloat(planoPackage[0].frame.offerPrice);

                        dispatch(setTotalDiscount((frameListPrice - frameOfferPrice).toFixed(2)));
                    } else {
                        dispatch(setTotalDiscount(null));
                    }
                }
            }
        }
    };

    useEffect(() => {
        if (data !== null) {
            // Reset totals on init
            if (resetTotalsOnInit) {
                resetTotals();
                dispatch(setResetTotalsOnInit(false));
            }

            // Check if GVP
            if (utils.checkGVP(data)) {
                dispatch(setIsGVP(true));
                dispatch(setTreatmentStepTitleInGvp(labels.steps.treatments.gvpTitle));
            } else {
                dispatch(setIsGVP(false));
            }
        }
    }, [data, isInsuranceEnabled]);

    useEffect(() => {
        if (selectedPackage == null) {
            resetTotals();
        }
    }, [selectedPackage, isInsuranceEnabled]);

    useEffect(() => {
        if (isInsuranceLogged !== null && isInsuranceLogged == false && data !== null) {
            // Clear all insurance prices
            let tempData = utils.deepCopy(data);
            tempData.packages.forEach(tempPackage => {
                tempPackage.frame.insPrice = null;
                tempPackage.lensPackage.insPrice = null;
            });
            dispatch(setData(tempData));
            dispatch(setInsuranceEnabled(false));
        }
    }, [isInsuranceLogged]);

    useEffect(() => {
        // Calculate selected packages based on selected options
        let baseLensPackages = [];

        if (selectedOptions !== null) {
            const selectedPackages = data.packages.filter(currentPackage => {
                const typeCheck =
                    !selectedOptions.type ||
                    (selectedOptions.type &&
                        currentPackage.lensPackage.type == selectedOptions.type);
                const brandCheck =
                    !selectedOptions.brand ||
                    (selectedOptions.brand &&
                        currentPackage.lensPackage.brand == selectedOptions.brand);
                const thicknessCheck =
                    !selectedOptions.thickness ||
                    (selectedOptions.thickness &&
                        currentPackage.lensPackage.thickness == selectedOptions.thickness);
                const polarCheck =
                    !selectedOptions.polar ||
                    (selectedOptions.polar &&
                        currentPackage.lensPackage.polar == currentPackage.lensPackage.polar);
                const arCheck =
                    !selectedOptions.antiReflective ||
                    (selectedOptions.antiReflective &&
                        currentPackage.lensPackage.antiReflective ==
                            selectedOptions.antiReflective);
                const blueLightCheck =
                    !selectedOptions.blueLight ||
                    (selectedOptions.blueLight &&
                        currentPackage.lensPackage.blueLight == selectedOptions.blueLight);
                const transitionCheck =
                    !selectedOptions.transition ||
                    (selectedOptions.transition &&
                        currentPackage.lensPackage.transition == selectedOptions.transition);
                const colorCategoryCheck =
                    !selectedOptions.colorCategory ||
                    (selectedOptions.colorCategory &&
                        currentPackage.lensPackage.colorCategory == selectedOptions.colorCategory);
                const colorCheck =
                    !selectedOptions.color ||
                    (selectedOptions.color &&
                        currentPackage.lensPackage.color == selectedOptions.color);
                const treatmentCheck =
                    !selectedOptions.treatment ||
                    (selectedOptions.treatment &&
                        currentPackage.lensPackage.treatment == selectedOptions.treatment);
                const prescriptionCheck = utils.hasValidPrescription(
                    currentPackage,
                    selectedPrescriptionObject
                );

                if (
                    typeCheck &&
                    brandCheck &&
                    thicknessCheck &&
                    (isGVP
                        ? treatmentCheck
                        : polarCheck &&
                          arCheck &&
                          blueLightCheck &&
                          transitionCheck &&
                          colorCategoryCheck) &&
                    colorCheck &&
                    prescriptionCheck
                ) {
                    if (currentPackage.lensPackage.isBaseLens) {
                        baseLensPackages.push(currentPackage);
                    }

                    return currentPackage;
                }
            });

            const _baseLensPackage = baseLensPackages.reduce((prevPackage, currentPackage) => {
                return currentPackage.lensPackage.listPrice < prevPackage.lensPackage.listPrice
                    ? currentPackage
                    : prevPackage;
            }, baseLensPackages[0]);

            if (_baseLensPackage) {
                dispatch(setBaseLensPackage(_baseLensPackage));
            }

            if (selectedPackages.length > 0) {
                let firstSelPackagePrices = {
                    listPrice:
                        parseFloat(config.data.frame.listPrice) +
                        parseFloat(selectedPackages[0].lensPackage.listPrice),
                    offerPrice:
                        parseFloat(selectedPackages[0].frame.offerPrice) +
                        parseFloat(selectedPackages[0].lensPackage.offerPrice),
                    package: _baseLensPackage ? _baseLensPackage : selectedPackages[0],
                };

                if (isInsuranceEnabled && selectedPackages[0].lensPackage.insurable == true) {
                    firstSelPackagePrices.offerPrice = 0.0;

                    // Insurance prices fallbacks to list prices
                    if (selectedPackages[0].frame.insPrice !== null) {
                        firstSelPackagePrices.offerPrice += parseFloat(
                            selectedPackages[0].frame.insPrice
                        );
                    } else {
                        firstSelPackagePrices.offerPrice += parseFloat(config.data.frame.listPrice);
                    }

                    if (selectedPackages[0].lensPackage.insPrice !== null) {
                        firstSelPackagePrices.offerPrice += parseFloat(
                            selectedPackages[0].lensPackage.insPrice
                        );
                    } else {
                        firstSelPackagePrices.offerPrice += parseFloat(
                            selectedPackages[0].lensPackage.listPrice
                        );
                    }
                }

                // Calculate subtotal and set selectedPackage to return
                const pricesAndPackage = selectedPackages.reduce(
                    (prevPackagePrices, selPackage) => {
                        let totalOfferPrice =
                            parseFloat(selPackage.frame.offerPrice) +
                            parseFloat(selPackage.lensPackage.offerPrice);

                        if (isInsuranceEnabled && selPackage.lensPackage.insurable == true) {
                            totalOfferPrice = 0.0;

                            if (selPackage.frame.insPrice !== null) {
                                totalOfferPrice += parseFloat(selPackage.frame.insPrice);
                            } else {
                                totalOfferPrice += parseFloat(config.data.frame.listPrice);
                            }

                            if (selPackage.lensPackage.insPrice !== null) {
                                totalOfferPrice += parseFloat(selPackage.lensPackage.insPrice);
                            } else {
                                totalOfferPrice += parseFloat(selPackage.lensPackage.listPrice);
                            }
                        }

                        const totalPrice =
                            parseFloat(config.data.frame.listPrice) +
                            parseFloat(selPackage.lensPackage.listPrice);

                        return totalPrice < parseFloat(prevPackagePrices.listPrice)
                            ? {
                                  listPrice: totalPrice,
                                  offerPrice: totalOfferPrice,
                                  package: _baseLensPackage ? _baseLensPackage : selPackage,
                              }
                            : prevPackagePrices;
                    },
                    firstSelPackagePrices
                );

                if (selectedOptions.thickness) {
                    dispatch(setTotalPrice(pricesAndPackage.listPrice.toFixed(2)));
                    dispatch(
                        setTotalDiscount(
                            (pricesAndPackage.listPrice - pricesAndPackage.offerPrice).toFixed(2)
                        )
                    );

                    const selectedPackageColor = pricesAndPackage.package.lensPackage.color;
                    const selectedPackageColorContent = data.content.color[selectedPackageColor];

                    if (selectedPackageColor && selectedPackageColorContent) {
                        dispatch(
                            setSelectedColorOption({
                                id: selectedPackageColor,
                                imageFileName1: selectedPackageColorContent.imageFileName1,
                                imageFileName2: selectedPackageColorContent.imageFileName2,
                                package: pricesAndPackage.package,
                                sequence: selectedPackageColorContent.sequence,
                                title: selectedPackageColorContent.title,
                            })
                        );
                    }
                } else {
                    resetTotals();
                }

                dispatch(setSelectedPackage(pricesAndPackage.package));
            } else {
                dispatch(setBaseLensPackage(null));
                dispatch(setSelectedPackage(null));
            }
        } else {
            dispatch(setSelectedPackage(null));
            dispatch(setBaseLensPackage(null));
        }

        if (
            selectedOptions &&
            (selectedOptions.colorCategory || selectedOptions.transition) &&
            selectedOptions.color &&
            config.data.frame.model &&
            config.data.frame.model !== '' &&
            config.data.frame.color &&
            config.data.frame.color !== '' &&
            config.data.frame.category &&
            config.data.frame.category.toUpperCase() === 'SUNGLASSES'
        ) {
            //Image composition
            if (productImageOld) dispatch(setProductImageOld(null));
        } else if (
            selectedOptions &&
            selectedOptions.brand &&
            config.data.frame.model &&
            config.data.frame.model !== '' &&
            config.data.frame.color &&
            config.data.frame.color !== ''
        ) {
            // Unbranded logic
            const productImage = config.data.frame.imageUrl;
            let extFramesImages = constants.frameImages;

            if (config.unbrandedFrameImages) {
                extFramesImages = {
                    ...extFramesImages,
                    ...config.unbrandedFrameImages,
                };
            }

            let frameOptions =
                extFramesImages[
                    config.data.frame.brand.replace('-', '').replace(' ', '').toLowerCase()
                ];

            if (frameOptions) {
                let lensbrand = selectedOptions.brand
                    .replace('-', '')
                    .replace(' ', '')
                    .toLowerCase();
                let framebrand = config.data.frame.brand
                    .replace('-', '')
                    .replace(' ', '')
                    .toLowerCase();

                if (framebrand == lensbrand && frameOptions[lensbrand]) {
                    let brandedProductImage = frameOptions[lensbrand]
                        .replace('#PARTNUMBER#', config.data.frame.upc)
                        .replace('#MO#', config.data.frame.model)
                        .replace('#CO#', config.data.frame.color);

                    //update frame images base endpoint if necessary
                    let oldWordRegEx = new RegExp(constants.baseURLs.framesImage, 'g');
                    brandedProductImage = brandedProductImage.replace(
                        oldWordRegEx,
                        baseURLs.framesImage
                    );
                    oldWordRegEx = new RegExp(constants.baseURLs.assetsCDN, 'g');
                    brandedProductImage = brandedProductImage.replace(
                        oldWordRegEx,
                        baseURLs.assetsCDN
                    );

                    dispatch(setBrandSelected(selectedOptions.brand));
                    dispatch(setProductImage(brandedProductImage));
                } else {
                    let unbrandedProductImage = frameOptions['unbranded']
                        .replace('#PARTNUMBER#', config.data.frame.upc)
                        .replace('#MO#', config.data.frame.model)
                        .replace('#CO#', config.data.frame.color);

                    //update frame images base endpoint if necessary
                    let oldWordRegEx = new RegExp(constants.baseURLs.framesImage, 'g');
                    unbrandedProductImage = unbrandedProductImage.replace(
                        oldWordRegEx,
                        baseURLs.framesImage
                    );
                    oldWordRegEx = new RegExp(constants.baseURLs.assetsCDN, 'g');
                    unbrandedProductImage = unbrandedProductImage.replace(
                        oldWordRegEx,
                        baseURLs.assetsCDN
                    );

                    dispatch(setBrandSelected(null));
                    dispatch(setProductImage(unbrandedProductImage));
                }
            } else {
                dispatch(setProductImage(productImage));
            }
        } else dispatch(setProductImage(config.data.frame.imageUrl));
    }, [selectedOptions]);

    useEffect(() => {
        if (isPrescriptionModalOpen) {
            prescriptionModalRef.current.focus();
        }
    }, [isPrescriptionModalOpen]);

    useEffect(() => {
        if (isPupillaryDistanceModalOpen) {
            PDModalRef.current.focus();
        }
    }, [isPupillaryDistanceModalOpen]);

    const getSingleType = () => {
        let singleType = null;
        let packages = null;

        if (
            (config.lensesData && data == null && frameUPC == null) ||
            (data !== null && frameUPC !== null && config.data.frame.upc !== frameUPC)
        ) {
            packages = config.lensesData.packages;
        } else {
            packages = data.packages;
        }

        if (packages !== null && !config.prescriptionModule) {
            const firstType = packages.filter(currentPackage => {
                if (currentPackage.lensPackage.type !== null) {
                    return currentPackage;
                }
            })[0].lensPackage.type;

            singleType = firstType;

            for (let i = 0; i < packages.length; i++) {
                const currentPackage = packages[i];

                if (
                    currentPackage.lensPackage.type !== null &&
                    currentPackage.lensPackage.type !== firstType
                ) {
                    singleType = null;
                    break;
                }
            }
        }

        return singleType;
    };

    const getSingleBrand = () => {
        let singleBrand = null;
        let packages = null;

        if (
            (config.lensesData && data == null && frameUPC == null) ||
            (data !== null && frameUPC !== null && config.data.frame.upc !== frameUPC)
        ) {
            packages = config.lensesData.packages;
        } else {
            packages = data.packages;
        }

        if (packages !== null) {
            let typePackages = null;

            if (selectedOptions !== null) {
                // Get all type filtered packages
                typePackages = packages.filter(currentPackage => {
                    if (currentPackage.lensPackage.type == selectedOptions.type) {
                        return currentPackage;
                    }
                });

                // If only one package then only one brand
                if (typePackages.length == 1) {
                    singleBrand = typePackages[0].lensPackage.brand;
                }
            } else {
                typePackages = packages.filter(currentPackage => {
                    if (currentPackage.lensPackage.brand !== null) {
                        return currentPackage;
                    }
                });
            }

            if (!singleBrand) {
                // Get the first brand
                const firstBrand = typePackages[0].lensPackage.brand;

                singleBrand = firstBrand;

                for (let i = 1; i < typePackages.length; i++) {
                    const typePackage = typePackages[i];

                    if (typePackage.lensPackage.brand !== firstBrand) {
                        singleBrand = null;
                        break;
                    }
                }
            }
        }

        return singleBrand;
    };

    const setDefaultImageOnError = e => {
        if (productImage !== config.data.frame.imageUrl) {
            dispatch(setProductImage(config.data.frame.imageUrl));
        }
    };

    return (
        <div
            className={'main-modal' + (isLearnMoreModalOpen ? ' hide-chat' : '')}
            style={{ display: isReadyCustomURL ? '' : 'none' }}
        >
            <div
                className="load-espot-hide"
                dangerouslySetInnerHTML={{ __html: contentOnLoad }}
            ></div>
            <MainHeader
                config={config}
                isInsuranceEnabled={isInsuranceEnabled}
                isInsuranceLoading={isInsuranceLoading}
                productName={config.data.frame.brand + ' ' + config.data.frame.name}
                totalPrice={
                    parseFloat(totalPrice) +
                    parseFloat(selectedWarranty ? selectedWarranty.price : 0.0)
                }
                totalDiscount={totalDiscount}
                handleBackClick={handleBackClick}
                handleOpenExit={handleOpenExit}
                handleAddInsurance={handleAddInsurance}
            />
            <ExitModal
                isLastStep={currentStep + 1 === constants.steps.length}
                isCartMode={config.cartMode}
                handleContinue={handleContinue}
                handleSave={handleSave}
                handleDiscard={handleDiscard}
                isOpen={isExitModalOpen}
            />
            {config.prescriptionModule && isSimplePrescription == false && (
                <Sidebar
                    rootId="pupillary_modal"
                    sidebar={
                        <div className="pupillary-distance-div">
                            <div
                                ref={PDModalRef}
                                className="close-modal"
                                onClick={closePDModal}
                                tabIndex={isPupillaryDistanceModalOpen ? '0' : '-1'}
                                onKeyPress={closePDModal}
                            />
                            {pupillaryDistanceEspotContent != null && (
                                <div
                                    className="pupillary-distance-container"
                                    dangerouslySetInnerHTML={{
                                        __html: pupillaryDistanceEspotContent,
                                    }}
                                ></div>
                            )}
                        </div>
                    }
                    open={isPupillaryDistanceModalOpen}
                    sidebarClassName={'pupillary-distance-modal' + (isMobile ? ' mob' : '')}
                    pullRight={true}
                    onSetOpen={closePDModal}
                    styles={{
                        sidebar: {
                            transition: 'transform .2s ease-out',
                            WebkitTransition: '-webkit-transform .2s ease-out',
                            zIndex: 6,
                        },
                        overlay: { backgroundColor: labels.sidebarOverlayColor },
                    }}
                />
            )}

            <Sidebar
                rootId="prescription_modal"
                sidebar={
                    <div className="prescription-modal-div">
                        <div
                            ref={prescriptionModalRef}
                            className="close-modal"
                            onClick={closePrescriptionModal}
                            tabIndex={isPrescriptionModalOpen ? '0' : '-1'}
                            onKeyPress={closePrescriptionModal}
                        >
                            <div className="close-modal-image"></div> {isMobile ? 'Back' : ''}
                        </div>
                        {prescriptionSidebarEspotContent != null && (
                            <div
                                className={'prescription-modal-container'}
                                dangerouslySetInnerHTML={{
                                    __html: prescriptionSidebarEspotContent,
                                }}
                            ></div>
                        )}
                    </div>
                }
                open={isPrescriptionModalOpen}
                sidebarClassName={'prescription-modal' + (isMobile ? ' mob' : '')}
                pullRight={true}
                onSetOpen={closePrescriptionModal}
                touchHandleWidth={0}
                dragToggleDistance={0}
                styles={{
                    sidebar: {
                        transition: 'transform .2s ease-out',
                        WebkitTransition: '-webkit-transform .2s ease-out',
                        zIndex: 6,
                    },
                    overlay: { backgroundColor: labels.sidebarOverlayColor },
                }}
            />
            {config.insuranceModule && (
                <InsurancePopup handleApply={handleApply} handleSkip={handleSkip} delay={6.6} />
            )}
            <div className="main-content" id="main-content">
                <div className={'product-container' + (isSafari ? ' safari' : '')}>
                    <a
                        href="#"
                        className="back-to-pdp"
                        onClick={handleOpenExit}
                        tabIndex={isAnyModalOpen ? '-1' : '0'}
                    >
                        {!config.cartMode ? labels.backToProductPage : labels.backToCart}
                    </a>
                    {brandDisclaimer &&
                        selectedOptions &&
                        selectedOptions.brand &&
                        isMoreOneBrand &&
                        errorLoadImage && (
                            <div
                                className={
                                    'brand-disclaimer' +
                                    (isLensGaming ? ' brand-disclaimer-lensgaming' : '')
                                }
                            >
                                {brandSelected
                                    ? brandDisclaimer.replace('[brand]', 'the ' + brandSelected)
                                    : brandDisclaimer.replace('with [brand]', 'without the')}
                            </div>
                        )}
                    <div className="product-name">
                        {config.data.frame.brand + ' ' + config.data.frame.name}
                    </div>
                    <div className="product-image-container">
                        {!editColorLens ||
                        (config.data.frame.category &&
                            config.data.frame.category.toUpperCase() === 'SUNGLASSES') ? (
                            !isLensGaming ? (
                                <>
                                    <ProductImage
                                        src={productImage}
                                        alt={config.data.frame.name}
                                        imgWidth={680}
                                        handleError={setDefaultImageOnError}
                                        imageErrorMessage={imageErrorMessage}
                                        lensErrorMessage={lensErrorMessage}
                                        isBrandSelection={
                                            selectedOptions &&
                                            selectedOptions.brand &&
                                            !selectedOptions.thickness
                                        }
                                    />
                                    {imageErrorMessage && (
                                        <>
                                            <span className="image-error-message">
                                                {labels.imageErrorMessage}
                                            </span>
                                        </>
                                    )}
                                    {lensErrorMessage && (
                                        <>
                                            <span className="image-error-message">
                                                {labels.lensErrorMessage}
                                            </span>
                                        </>
                                    )}
                                </>
                            ) : (
                                <div className="image-gaming">
                                    <ImageSlider lensFilename="Gaming_sun" />
                                </div>
                            )
                        ) : (
                            <>
                                <div className="image-slider-desktop">
                                    <ImageSlider
                                        lensFilename="white-lens"
                                        colorFilename={
                                            selectedColorOption !== null
                                                ? selectedColorOption.imageFileName2
                                                : 'white-lens'
                                        }
                                    />
                                </div>
                            </>
                        )}
                    </div>
                    {config.data.frame.brandImageUrl ? (
                        <div className="product-brand-container">
                            <img
                                src={config.data.frame.brandImageUrl}
                                alt={config.data.frame.brand}
                                className="product-brand"
                            />
                        </div>
                    ) : null}
                </div>
                <StepContainer
                    config={config}
                    handleAddInsurance={handleAddInsurance}
                    handleBackClick={handleBackClick}
                    getSingleType={getSingleType}
                    getSingleBrand={getSingleBrand}
                    hasPrescriptionStep={config.prescriptionModule && isSimplePrescription == false}
                    isSimplePrescription={isSimplePrescription}
                    warrantyOptions={config.data.warrantyOptions}
                />
            </div>
            <input aria-label="Configurator end" id="rxc-wcag-end" type="checkbox" />
        </div>
    );
};
